// extracted by mini-css-extract-plugin
module.exports = {"SideBar":"CabinetSideBar_SideBar__jMp4H","left":"CabinetSideBar_left__ukLOy","active":"CabinetSideBar_active__1zlKb","logout":"CabinetSideBar_logout__28Zvc"};